import Box from "@mui/material/Box";
import type { SxProps, Theme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import {
  NOT_WIDE,
  TINY,
  marketingPalette,
} from "@/components/marketing/tokens";
import type { Laid } from "@/content/landing/sectionLayout";
import { LandingImage, LandingSection } from "../LandingPrimitives";
import { FLOW_MEASURE, flowSection } from "./landingRun";

type Quote = Laid<"quote">;

/**
 * `.eth-cta_wrap`: one line in quotation marks under a small logo, centred on
 * a panel washed from straw to mint. It stands in the ethics page's flowing
 * column, so the section around it is the column's.
 */
const PANEL = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "20px",
  width: 1,
  p: "48px 112px",
  borderRadius: "32px",
  backgroundImage: "linear-gradient(88deg, #f7f6e8, #e6fdf6)",
  [NOT_WIDE]: { p: "32px 64px" },
  [TINY]: { px: "32px" },
} satisfies SxProps<Theme>;

/** `.eth-cta_logo`: 26 tall, 24 on a phone, as wide as that makes it. */
const LOGO = {
  height: "26px",
  width: "auto",
  [TINY]: { height: "24px" },
} satisfies SxProps<Theme>;

/** `.eth-cta_title` */
const LINE = {
  color: marketingPalette.inkMuted,
  textAlign: "center",
  fontSize: 20,
  lineHeight: "30px",
  fontWeight: 500,
  [TINY]: { fontSize: 17.6, lineHeight: "24.64px" },
} satisfies SxProps<Theme>;

export default function QuoteBlock({ block }: { block: Quote }) {
  return (
    <LandingSection {...flowSection(block)}>
      <Box sx={FLOW_MEASURE}>
        <Box sx={PANEL}>
          {block.logo ? <LandingImage src={block.logo} sx={LOGO} /> : null}
          <Typography sx={LINE}>{block.text}</Typography>
        </Box>
      </Box>
    </LandingSection>
  );
}
